import Axios from 'axios'
import { preprocessErrorResponse, createBasicAuthConfig } from '../util/api'
import store from './index'

const defaultState = () => ({
  isFetching: false,
  searchingProfName: '',
  searchedProfName: '',
  startYearRange: null,
  endYearRange: null,
  rawPapers: [],
  sortBy: 'year', // year, cite, title ...
  orderBy: 'desc' // asc, desc,
})

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    papers(state) {
      const result = []
      const _startYearRange = state.startYearRange ? state.startYearRange : 0;
      const _endYearRange = state.endYearRange ? state.endYearRange : new Date().getFullYear();

      //filter by year range
      for (const paper of state.rawPapers) {
        if (paper.year >= _startYearRange && paper.year <= _endYearRange) {
          result.push(paper)
        }
      }

      //ordering
      const reverseFlag = state.orderBy === 'desc' ? -1 : 1;
      switch (state.sortBy) {
        case 'year':
          result.sort((a, b) => (a.year - b.year) * reverseFlag)
          break
        case 'cite':
          result.sort((a, b) => (a.cite - b.cite) * reverseFlag)
          break
      }
      return result
    },
    selectedPapersLength(state) {
      return state.rawPapers.filter(x => x.selected === true).length
    }
  },
  mutations: {
    setIsFetching(state, payload) {
      state.isFetching = payload
    },
    setRawPapers(state, payload) {
      state.rawPapers = payload
    },
    setStartYearRange(state, payload) {
      state.startYearRange = payload
    },
    setEndYearRange(state, payload) {
      state.endYearRange = payload
    },
    setSearchingProfName(state, payload) {
      state.searchingProfName = payload
    },
    setSearchedProfName(state, payload) {
      state.searchedProfName = payload
    },
    setSortBy(state, payload) {
      state.sortBy = payload
    },
    setOrderBy(state, payload) {
      state.orderBy = payload
    },
    toggleSelectPaperRecord(state, id) {
      for (const paper of state.rawPapers) {
        if (paper.id === id) {
          paper.selected = !paper.selected;
          return;
        }
      }
    },
    selectAllRecords(state) {
      for (const paper of state.rawPapers) {
        paper.selected = true;
      }
    },
    deselectAllRecords(state){
      for (const paper of state.rawPapers){
        paper.selected = false
      }
    },
    reset(state) {
      Object.assign(state, defaultState())
    }
  },
  actions: {
    async fetchPapers({ state, commit }) {
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API
      let result = {}
      commit('setIsFetching', true)
      commit('setRawPapers', [])
      const config = createBasicAuthConfig(
        store.state.authentication.token
      )
      await Axios.get(
        SERVER_ADDRESS + API.CRAWL_PAPER + state.searchingProfName,
        config)
        .then((resp) => {
          commit('setSearchedProfName', state.searchingProfName)
          commit('setRawPapers', resp.data.papers.map(
            (x, idx) => Object.assign(x, { selected: false, id: idx })))
          result = resp.data
        })
        .catch((err) => {
          result = preprocessErrorResponse(err)
        })
      commit('setIsFetching', false)
      return result
    }
  },
}
